const TermsandConditionsContent = ({ contentConfig }: any) => {
  return (
    <>
      log
      <div className=" text-sm">
        These Terms and Conditions ("Terms") govern your use of the {contentConfig?.systemName} provided by {contentConfig?.universityName} ("we,"
        "us," or "our"). By accessing or using the LMS, you agree to be bound by these Terms. If you do not agree to abide by these Terms, please
        refrain from accessing or using the LMS.
      </div>
      <div className="font-bold mb-2 mt-4">1. Use of the LMS:</div>
      <div className=" text-sm  mb-2">
        1.1. You must be a registered student, faculty, or staff member of <span className=" font-bold">{contentConfig?.universityName}</span> to
        access and use the LMS.
      </div>
      <div className=" text-sm  mb-2">
        1.2. You agree to use the LMS only for lawful purposes and in accordance with these Terms, any applicable policies of{' '}
        <span className=" font-bold">{contentConfig?.universityName}</span>, and all applicable laws and regulations.
      </div>
      <div className=" text-sm  mb-2">
        1.3. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your account. You
        agree to accept responsibility for all activities that occur under your account or password.
      </div>
      <div className="font-bold mb-2 mt-4">2. Intellectual Property:</div>
      <div className=" text-sm  mb-2">
        2.1. The LMS, including all content, features, and functionality thereof, are owned by{' '}
        <span className=" font-bold">{contentConfig?.universityName}</span> and are protected by copyright, trademark, and other intellectual property
        laws.
      </div>
      <div className=" text-sm  mb-2">
        2.2. You may access and use the LMS and its content only for your personal, non-commercial use in connection with your role as a student,
        faculty, or staff member of <span className=" font-bold">{contentConfig?.universityName}</span>.
      </div>
      <div className=" text-sm  mb-2">
        2.3. You may not modify, reproduce, distribute, create derivative works of, publicly display, publicly perform, republish, download, store, or
        transmit any of the material on the LMS, except as expressly permitted by these Terms or with the prior written consent of{' '}
        <span className=" font-bold">{contentConfig?.universityName}</span>.
      </div>
      <div className="font-bold mb-2 mt-4">3. User Content:</div>
      <div className=" text-sm  mb-2">
        3.1. The LMS may allow you to post, upload, transmit, or otherwise make available content, including but not limited to assignments,
        discussions, and messages ("User Content").
      </div>
      <div className=" text-sm  mb-2">
        3.2. By posting User Content on the LMS, you represent and warrant that you have the right to do so and that your User Content does not
        violate the rights of any third party or any applicable law or regulation.
      </div>
      <div className=" text-sm  mb-2">
        3.3. You retain ownership of your User Content, but by posting it on the LMS, you grant{' '}
        <span className=" font-bold">{contentConfig?.universityName}</span> a non-exclusive, royalty-free, perpetual, irrevocable, and fully
        sublicensable right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display such User
        Content throughout the world in any media.
      </div>
      <div className="font-bold mb-2 mt-4">4. Privacy:</div>
      <div className=" text-sm  mb-2">
        4.1. Your use of the LMS is subject to <span className=" font-bold">[{contentConfig?.universityName}]</span> Privacy Policy, which is
        incorporated into these Terms by reference. By using the LMS, you consent to the collection, use, and disclosure of your information as
        described in the Privacy Policy.
      </div>
      <div className="font-bold mb-2 mt-4">5. Termination:</div>
      <div className=" text-sm  mb-2">
        5.1. <span className=" font-bold">{contentConfig?.universityName}</span> may terminate or suspend your access to the LMS, in whole or in part,
        at any time, with or without cause, and with or without notice.
      </div>
      <div className=" text-sm  mb-2">
        5.2. Upon termination of your access to the LMS, all provisions of these Terms which by their nature should survive termination, including but
        not limited to provisions regarding intellectual property, user content, and limitations of liability, shall survive such termination.
      </div>
      <div className="font-bold mb-2 mt-4">6. Limitation of Liability:</div>
      <div className=" text-sm  mb-2">
        6.1. In no event shall <span className=" font-bold">{contentConfig?.universityName}</span>, its officers, directors, employees, or agents, be
        liable to you for any indirect, incidental, special, consequential, or punitive damages, including but not limited to damages for loss of
        profits, goodwill, use, data, or other intangible losses, arising out of or relating to your use of the LMS, even if{' '}
        <span className=" font-bold">{contentConfig?.universityName} </span>has been advised of the possibility of such damages.
      </div>
      <div className="font-bold mb-2 mt-4">7. Governing Law:</div>
      <div className=" text-sm  mb-2">
        7.1. These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction], without regard to its conflict of law
        provisions.
      </div>
      <div className="font-bold mb-2 mt-4">8. Changes to Terms:</div>
      <div className=" text-sm  mb-2">
        8.1. <span className=" font-bold">{contentConfig?.universityName} </span>reserves the right, at its sole discretion, to modify or replace
        these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What
        constitutes a material change will be determined at our sole discretion.
      </div>
      <div className=" text-sm  mb-2">
        8.2. By continuing to access or use the LMS after any revisions to these Terms become effective, you agree to be bound by the revised terms.
        If you do not agree to the new terms, please stop using the LMS.
      </div>
      <div className="font-bold mb-2 mt-4">9. Contact Information:</div>
      <div className=" text-sm  mb-2">9.1. If you have any questions about these Terms, please contact us at [{contentConfig?.supportEmail}].</div>
      <div className=" text-sm  mb-2">
        By accessing or using the LMS, you acknowledge that you have read, understood, and agree to be bound by these Terms.
      </div>
    </>
  );
};

export default TermsandConditionsContent;
